/**
 * @file Reads a served receivable aging bucket cell. Consumers:
 * `analyticsInvoices` and `analyticsReceivableAging`. A known bucket reads as
 * itself and null stays null (an invoice with no due date); any other value,
 * including an absent cell, is `undefined` (malformed).
 */
import { ANALYTICS_AGING_BUCKETS } from '#types';
import type { AnalyticsAgingBucket, NamedQueryCell } from '#types';

export const analyticsAgingBucketCell = (
  cell: NamedQueryCell | undefined,
): AnalyticsAgingBucket | null | undefined =>
  cell === null
    ? null
    : ANALYTICS_AGING_BUCKETS.find((bucket) => bucket === cell);
